import styled from 'styled-components';

export const CollaboratorsPercentage = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	place-items: center;
`;

export const CollaboratorText = styled.p`
	font-family: 'Montserrat';
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 22px;
	color: #64778f;

	& > span {
		font-weight: 600;
	}
`;

export const CollaboratorsAttencion = styled.div<{ variant?: boolean }>`
	& div:first-child {
		margin-bottom: ${({ variant }) => (variant ? '10px' : 'unset')};
	}
	margin-left: 28px;
`;

export const ReferButton = styled.div`
	font-family: 'Montserrat', 'Arial', sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 22px;
	text-decoration-line: underline;
	color: #5082c2;
	cursor: pointer;

	&:hover {
		text-decoration-line: none;
	}
`;
